// eslint-disable-next-line no-unused-vars
import { React, useState, useEffect } from "react";
import {
	AddproductWrapper,
	Title,
	AddButtonGroup,
} from "../ProductsPage.styled";
// import SwiperNavButtons from "../../../components/ReusableComponents/SwiperNavButtons";
import SingleProductForm from "../Forms/SingleProductForm";
import { getFormattedAmount } from "../../../utils/AmountUtils";
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";
import Parse from "../../../api/ApiConfig";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import { GrPrevious, GrNext } from "react-icons/gr";
import { Button } from "../Forms/ProductForm.styled";
import { AiFillCheckCircle } from "react-icons/ai";
import { MdOutlineCancel } from "react-icons/md";
import ConfirmModal from "../../../components/ConfirmModal";
import { canPerformAction } from "../../../utils/UserAuth";
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../../redux/AppSlice";
import { useParams, useNavigate } from "react-router";


// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function SingleProduct() {
	const [ProductForm, SetProductForm] = useState({
		date: "",
		productName: "",
		shelfLife: "",
		admin: "",
		category: "",
		subCategory: "",
		amount: "",
		brand: "",
		model: "",
		year: "",
		totalUnits: "",
		availableUnits: "",
		condition: "",
		color: "",
		tags: "",
		image: "",
		description: "",
		keyFeatures: "",
		specifications: "",
	});
	const [confirmModal, setConfirmModal] = useState(false);
	const [productName, setProductName] = useState("");
	const [productPrice, setProductPrice] = useState("");
	const [isFormSaved, setIsFormSaved] = useState(true);
	const [modalText, setModalText] = useState("");
	const [imageUrl, setImagesUrl] = useState({
		previewImageUrl: "",
		firstImageUrl: "",
		secondImageUrl: "",
		thirdImageUrl: "",
	});
	const dispatch = useDispatch();
	let { productId } = useParams();
	const navigate = useNavigate();
	// eslint-disable-next-line no-unused-vars

	useEffect(() => {
		const swiper = document.querySelector(".mySwiper").swiper;
		let next = document.getElementById("next");
		next.addEventListener("click", () => {
			swiper.slideNext(800);
		});

		let prev = document.getElementById("prev");
		prev.addEventListener("click", () => {
			swiper.slidePrev(800);
		});
	}, []);

	const [parseImage, setParseImages] = useState({
		firstImage: "",
		secondImage: "",
		thirdImage: "",
	});

	let imageFile;
	const handleImageUpload = (event, position) => {
		if (position === "first") {
			const file = event.target.files[0];
			const reader = new FileReader();
			reader.onload = () => {
				setImagesUrl({
					...imageUrl,
					firstImageUrl: reader.result,
					previewImageUrl: reader.result,
				}); //set clciked upload to the review image
			};
			// setImageList(current =>[...current, reader.result]);
			if (file) {
				reader.readAsDataURL(file);
				saveImageToParse(file, position); //save image url to parse server
			}
		} else if (position === "second") {
			const file = event.target.files[0];
			const reader = new FileReader();
			reader.onload = () => {
				setImagesUrl({
					...imageUrl,
					secondImageUrl: reader.result,
				});
			};
			if (file) {
				reader.readAsDataURL(file);
				saveImageToParse(file, position);
			}
		} else {
			const file = event.target.files[0];
			const reader = new FileReader();
			reader.onload = () => {
				setImagesUrl({
					...imageUrl,
					thirdImageUrl: reader.result,
				});
			};
			if (file) {
				reader.readAsDataURL(file);
				saveImageToParse(file, position);
			}
		}
	};

	const saveImageToParse = async (file, position) => {
		dispatch(setLoadingState(true));
		try {
			const sanitizedFileName = file.name.replace(/[^\w.-]+/g, "");
			imageFile = new Parse.File(sanitizedFileName, file);
			await imageFile.save();
			dispatch(setLoadingState(false));
			toast.success("Image Saved");
			if (position === "first") {
				setParseImages({ ...parseImage, firstImage: imageFile });
			} else if (position === "second") {
				setParseImages({ ...parseImage, secondImage: imageFile });
			} else {
				setParseImages({ ...parseImage, thirdImage: imageFile });
			}
		} catch (error) {
			dispatch(setLoadingState(false));
			toast.error(
				"Error saving item: filename consists of invalid characters",
				error
			);
			console.error("Error saving item:", error);
		}
	};

	const handleStatus = (status) => {
		if (status === "approve") {
			updateProductStatus("approve");
		} else {
			updateProductStatus("unapprove");
		}
	};

	const setModal = (status) => {
		console.log(productId)
		setConfirmModal(true);
		if (status === "approve") {
			setModalText({
				header: "Approve Product",
				desc: "Are you sure you want to approve this product?",
				btnText: "Yes, Approve",
				status: "approve",
			});
		} else {
			setModalText({
				header: "Unapprove Product",
				desc: "Are you sure you want to unapprove this product?",
				btnText: "Yes, Unapprove",
				status: "unapprove",
			});
		}
	};

	const updateProductStatus = async (status) => {
		// dispatch(setLoadingState(true));
		try {
			let Product = Parse.Object.extend("Products");
			const ProductObject = new Product();
			ProductObject.id = productId;
			ProductObject.save({
				approve: status === "approve" ? true : false,
			}).then(() => {
				// dispatch(setLoadingState(false));
				navigate("/products");
				toast.success("Product status updated successfully!");
			});
		} catch (error) {
			console.log(error);
			// dispatch(setLoadingState(false));
			toast.error("Error updating Product status!");
		}
	};

	return (
		<AddproductWrapper>
			{confirmModal && (
				<ConfirmModal
					confirmModal={confirmModal}
					setConfirmModal={setConfirmModal}
					content={{
						title: modalText?.header,
						desc: modalText?.desc,
						btnText: modalText?.btnText,
					}}
					handleDeleteAction={() => handleStatus(modalText?.status)}
				/>
			)}
			<Title>Product Information</Title>
			<main>
				<div className='LeftSection'>
					<div className='productDetails'>
						<div className='buttons'>
							<button className='absolute-prev' id='prev'>
								<GrPrevious size={28} />
							</button>
							<button className='absolute-next' id='next'>
								<GrNext size={28} />
							</button>
						</div>
						<Swiper
							// navigation={true}
							modules={[Pagination, Autoplay, Navigation]}
							className='mySwiper'
							loop={true}
						>
							{[
								imageUrl.firstImageUrl,
								imageUrl.secondImageUrl,
								imageUrl.thirdImageUrl,
							].map((url, index) => {
								return (
									<SwiperSlide key={index}>
										<img src={url || "/images/placeholder_img.jpg"} />
									</SwiperSlide>
								);
							})}
						</Swiper>

						<p className='name'>{productName}</p>
						<p className='price'>
							{productPrice === "Price"
								? productPrice
								: getFormattedAmount.format(productPrice)}
						</p>
					</div>

					<AddButtonGroup>
						<Tooltip title='change primary Image' arrow>
							<label htmlFor='image'>
								<img
									className=''
									style={{ width: "80px", height: "80px" }}
									src={imageUrl.firstImageUrl || "/images/placeholder_img.jpg"}
									alt='import button'
								/>

								<input
									type='file'
									accept='image/*'
									name='image'
									id='image'
									disabled={isFormSaved}
									onChange={(e) => handleImageUpload(e, "first")}
								/>
							</label>
						</Tooltip>

						<Tooltip title='change secondary Image' arrow>
							<label htmlFor='image2'>
								<img
									style={{ width: "80px", height: "80px" }}
									src={imageUrl.secondImageUrl || "/images/placeholder_img.jpg"}
									alt='import button'
								/>

								<input
									type='file'
									accept='image/*'
									name='image'
									id='image2'
									disabled={isFormSaved}
									onChange={(e) => handleImageUpload(e, "second")}
								/>
							</label>
						</Tooltip>

						<Tooltip title='change Image' arrow>
							<label htmlFor='image3'>
								<img
									className=''
									style={{ width: "80px", height: "80px" }}
									src={imageUrl.thirdImageUrl || "/images/placeholder_img.jpg"}
									alt='import button'
								/>

								<input
									type='file'
									accept='image/*'
									name='image'
									id='image3'
									disabled={isFormSaved}
									onChange={(e) => handleImageUpload(e, "third")}
								/>
							</label>
						</Tooltip>
					</AddButtonGroup>

					{/* //conditionally render approval buttons */}
					{canPerformAction("edit", "products") &&
						(ProductForm?.approve ? (
							<Button
								className='ma mt-8'
								type='submit'
								custom={'.2rem'}
								onClick={() => setModal("unapprove")}
								color='#ffffff'
								backgroundcolor='#003A50'
							>
								<MdOutlineCancel size={24} />
								<p>Unapprove</p>
							</Button>
						) : (
							<Button
								className='ma mt-8'
								type='submit'
								onClick={() => setModal("approve")}
								color='#ffffff'
								custom={'.2rem'}
								backgroundcolor='#003A50'
							>
								<AiFillCheckCircle size={24} />
								<p>Approve Product</p>
							</Button>
						))}
				</div>

				<div className='productForm'>
					<SingleProductForm
						setProductName={setProductName}
						setProductPrice={setProductPrice}
						setImagesUrl={setImagesUrl}
						isFormSaved={isFormSaved}
						parseImage={parseImage}
						setIsFormSaved={setIsFormSaved}
						SetProductForm={SetProductForm}
						ProductForm={ProductForm}
					/>
				</div>
			</main>
		</AddproductWrapper>
	);
}

export default SingleProduct;
